module.exports = __webpack_public_path__ + "img/arrow.c8cb41c2.svg";